import type { ImportRowDraft } from '@shared/models/element-import.model';
import { getImportRowDraft } from '@shared/helpers/import-row-draft.helpers';
import { useSelectedVersion } from '@client/store/ui';

/** Reactively read a candidate row's mapping draft from the selected version. */
export const useImportRowDraft = (rowId: string): ImportRowDraft => {
  const version = useSelectedVersion();
  return getImportRowDraft(version, rowId);
};
